// extracted by mini-css-extract-plugin
module.exports = {"busy":"taxatie-aanvragen_busy__K59Ee","spin":"taxatie-aanvragen_spin__28Ds2"};